import { render, staticRenderFns } from "./TextOnImage.vue?vue&type=template&id=04c63e98"
import script from "./TextOnImage.vue?vue&type=script&lang=js"
export * from "./TextOnImage.vue?vue&type=script&lang=js"
import style0 from "./TextOnImage.vue?vue&type=style&index=0&id=04c63e98&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports